import '@vas2t-informat/utils/sri-hashes';
import('./bootstrap');
